export const DEMO_KULIAH_PRESETS = Object.freeze([
  Object.freeze({ id: "subuh", title: "Kuliah Subuh", time: "05:45" }),
  Object.freeze({ id: "maghrib", title: "Kuliah Maghrib", time: "19:30" }),
  Object.freeze({ id: "dhuha", title: "Kuliah Dhuha", time: "09:00" }),
]);

export const DEMO_SPEAKERS = Object.freeze([
  Object.freeze({ id: "ustaz-demo-1", name: "Ustaz Ahmad Demo", avatarKey: "ustaz-ahmad", image: "/assets/demo/speakers/ustaz-ahmad.svg" }),
  Object.freeze({ id: "ustaz-demo-2", name: "Ustaz Bilal Demo", avatarKey: "ustaz-bilal", image: "/assets/demo/speakers/ustaz-bilal.svg" }),
  Object.freeze({ id: "ustaz-demo-3", name: "Ustaz Firdaus Demo", avatarKey: "ustaz-firdaus", image: "/assets/demo/speakers/ustaz-firdaus.svg" }),
]);

export const DEMO_BOOKS = Object.freeze([
  Object.freeze({ id: "kitab-demo-1", title: "Riyadus Solihin (Demo)" }),
  Object.freeze({ id: "kitab-demo-2", title: "Tafsir Pilihan (Demo)" }),
  Object.freeze({ id: "kitab-demo-3", title: "Fiqh Harian (Demo)" }),
]);
